import { openBlock as t, createElementBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(a, e) {
  return t(), o("svg", n, [...e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      d: "M20.5 7a.5.5 0 0 1 0 1h-17a.5.5 0 0 1 0-1zm-7 10a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm4-5a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1z"
    }, null, -1)
  ])]);
}
const c = { render: l };
export {
  c as default,
  l as render
};
